/*global jQuery:false */
/*jshint bitwise: false*/

jQuery(function ($) {
	
	"use strict";

	 var iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false ); if(iOS)	{ $('.custom-select select').css('font-size', '16px'); } 
		 
	/* Initiate lazyloading */	 
	window.lazySizesConfig = {
		addClasses: true
	};

	/**
	 * Initiate the sticky header script.
	 *
	 * @link http://www.hongkiat.com/blog/css-sticky-position/
	 */ 
	function setup_sticky_navbar() {
		var navbar = $('#navbar');
		if (navbar.length) {
			var stickyNavTop = navbar.offset().top-10;  
			
			var stickyNav = function(){  
				var scrollTop = $(window).scrollTop();  
				       
				if (scrollTop > stickyNavTop) {   
				    navbar.addClass('fixed');
				} else {  
				    navbar.removeClass('fixed');  
				}  
			}; 
			  
			stickyNav();  
			  
			$(window).scroll(function() {  
			    stickyNav();  
			});
		}
	}
	setup_sticky_navbar();	

	function setup_location_services_form(id) {
		var $services_dd = $('#select-services'+id);

		function update_find_counselors_url() {
			var url = $services_dd.attr('data-directory-page-url'),
				service = $services_dd.find('option:selected').val();

			if ( 'none' !== service ) {
				window.location = url + '/services/' + service;
			}			
		}

		$services_dd.on('change', function() {
			update_find_counselors_url();
		});
	}
	setup_location_services_form('');
	setup_location_services_form('-hiw');
	 	 
    /**
     * Initiate the responsive header function. We use picturefill instead.
     *
     * @link http://www.webdesignerdepot.com/2012/09/creating-a-responsive-header-in-wordpress-3-4/
     */
	document.createElement( "picture" );

	/**
	 * Create Parallax effect header image.
	 *
	 * This is the only good parallax script that works with the img element.
	 * Almost all other scripts use background positioning for the parallax.
	 *
	 * @link http://www.vandelaydesign.com/parallax-wordpress/
	 */
	function setup_parallax_image() { 
		 function parallax_image($max, $image) {
			 
			var intensity = 0.25; //Should not go higher than 0.5 to prevent bottoming out.
			
			var imgTop = 0, scrollPos = $(window).scrollTop();
				
			//rule of thirds to find the new top position for image
			imgTop = (scrollPos / $max) * (intensity) * $image.height();
			
			$image.css({
				"top": -(imgTop)+"px"
			});
		}
		$(window).load(function(){
			var $banner = $("#site-header-image"), $image = $banner.find("img"), $height = 0, $max = 0;
			// var $header_title = $banner.find("#header-title");
			
			//height = $banner.find("img").height() / 3;
			//we set our own height for consistency
			if ( $banner.hasClass('counselor-bar') ) {
				$height = 450;
			} else if ( $('body').hasClass('single-service') ) {
				$height = 450;	
			} else {
				$height = 250;
			}
			$banner.height($height);
				
			//this is the maxiumum amount of scroll for still visible banner, cached to improve performance
			$max = ($banner.offset()).top + $height;
			
			$(window).scroll(function() {	      
			   parallax_image($max, $image);	      
			});
		});
	}
	//setup_parallax_image();

	/**
	 * Fade out container on scroll up.
	 *
	 */	
	function setup_container_fade() {
		
	    var divs = $('.no-counselor-bar #header-title');
	    var intensity = 200;
	    
	    $(window).on('scroll', function() {
	        var st = $(this).scrollTop();
	        divs.css({  
	            'opacity' : 1 - st/intensity
	        }); 
	    });
	}
	//setup_container_fade();

	/**
	 * Load the front page who we are section
	 */
	function setup_front_page_who_we_are() {
		var $who    = $( "#who" ),
			ajaxURL = $who.attr('data-ajax-url');

		$who.hide().load( ajaxURL, { action: 'front-page-who-we-are' }, function() {
			$who.fadeIn();
		} );

	}
	if( $('body').hasClass('page-template-front-page') ) {
		setup_front_page_who_we_are();
	}

    /**
     * Initiate the owl profiles carousel function.
     *
     * @link http://owlgraphic.com/owlcarousel/#how-to
     */
    
	function setup_profiles_carousel() {
		
		var profiles = $('#what-who-how #profiles');
		
		if(profiles.length) {
		    profiles.owlCarousel({
		        itemsCustom: [
		            [0, 3], //items between 0 and 320px
		            [567, 4], //items between 480px and 767px
		            [768, 5], //items between 786px and 959px
		            [1600, 6] //items above 1600px
		        ],
		        navigation: false,
				autoPlay: 6000,
				stopOnHover: true,
		        slideSpeed: 400
		    });    
		}	
	}
	//setup_profiles_carousel();	

    /**
     * Initiate the owl testimonials carousel function.
     *
     * @link http://owlgraphic.com/owlcarousel/demos/autoHeight.html
     */

	function setup_testimonials_carousel() {
		
		var testimonials = $('.testimonials-list');
		
		if(testimonials.length) {
		    testimonials.owlCarousel({
				singleItem: true,
				autoPlay: 10000,
				//autoHeight: true,
				stopOnHover: true,
		        slideSpeed: 400,
		        pagination: false,
		        navigation: true,
		        navigationText: [
		            "<i class='fa fa-caret-left'></i>", // Arrow left  Dash Icons
		            "<i class='fa fa-caret-right'></i>" // Arrow right Dash Icons
		        ]
		    });
	    }
    }
	setup_testimonials_carousel();    

	/**
	 * Initiate the owl locations carousel function.
	 *
	 */

	function setup_locations_carousel() {
		var locations_portrait = $("#locations-portrait ul");
		var location_item = $("ul.office-locations").find("li.location");
		
		if (locations_portrait.length) {
			locations_portrait.owlCarousel({
				itemsCustom : [
					[0, 0],
					[480, 2],
					[740, 3],
					[940, 4],
					[1160, 5]
				],
				lazyLoad : true,
				scrollPerPage: true,
				slideSpeed : 700,
				paginationSpeed : 500,
				pagination: false,
				navigation : true,
				slideBy: 'page',
				navigationText : [
					"<i class='fa fa-angle-left'></i>",
					"<i class='fa fa-angle-right'></i>"
		     	]
			});   
		}
		
	    location_item.find('div.spacer').click(function() {
	            $(this).parent().toggleClass('open').find(".location-details").slideToggle('slow');
				$(this).parent().find("i").toggleClass("fa-caret-up");
				$(this).parent().find("i").toggleClass("fa-caret-down");
	    });	    		
	}
	setup_locations_carousel();

	function setup_location_counselors_carousel() {
		
		var counselor_wrapper = $('#counselors-list-wrapper');
		
		if(counselor_wrapper.length) {
		    counselor_wrapper.owlCarousel({
				singleItem: true,
				//autoPlay: 10000,
				//autoHeight: true,
				//stopOnHover: true,
		        slideSpeed: 400,
		        pagination: false,
		        navigation: true,
		        navigationText: [
		            "<i class='fa fa-caret-left'></i>", // Arrow left  Dash Icons
		            "<i class='fa fa-caret-right'></i>" // Arrow right Dash Icons
		        ]
		    });
	    }
    }
	setup_location_counselors_carousel();
		
	function setup_funnel() {
		// Variables
		var $funnelButton    = $('#service-steps-init'),
			$funnelSection   = $('section#service-steps'),
			// $h2              = $funnelSection.find('h2:first'),
			$locationsPanel  = $('#steps-content .step-location:first'),
			$servicesPanel   = $('#steps-content .step-service:first'),
			$counselorsPanel = $('#steps-content .step-counselor:first'),
			$schedulePanel   = $('#steps-content .step-schedule:first'),
			$loadingPanel    = $('#steps-content .loading-step:first'),
			$visiblePanel    = $locationsPanel,
			$stepQuestions   = $('#questions'),
			$stepsBar        = $('#steps-bar'),
			$scheduleButton  = $('#questions .confirm-btn:first'),
			ajaxURL          = $funnelSection.attr('data-funnel-url'),
			isBusy           = false,
			currentLocation  = false,
			locationName     = '',
			currentService   = false,
			serviceName      = '',
			currentCounselor = false,
			counselorName    = '',
			locationFirst    = ($funnelSection.attr('data-funnel-location-first') === '1'),
			funnelShowing    = false,
			initialLocation  = $funnelSection.attr('data-funnel-location'),
			initialService   = $funnelSection.attr('data-funnel-service'),
			disableScroll    = false,
			funnelButtonVis  = true;

		$stepQuestions.find('h3 span').each(function() {
			var $this = $(this);
			$this.attr('data-funnel-default-text', $this.text());
		});
		$stepsBar.find('.selection').each(function() {
			var $this = $(this);
			$this.attr('data-funnel-default-text', $this.text());
		});

		// Function to scroll to start funnel		
		function goToByScroll($element) {
			if (disableScroll) {
				return;
			}
			if (!$element.length) {
				return;
			}
		    $('html,body').animate({
		        scrollTop: $element.offset().top-50
		    }, 'slow');
		}

		// Open the funnel
		$(document).on('click.funnel', "[data-funnel-cmd='open']", function(event) {
			event.preventDefault();

			var view = locationFirst ? 'locations' : 'services';

			if(funnelShowing) {
				goToByScroll( $funnelSection );
			}

			$.bbq.pushState({ v: view });
		});

		// Close the funnel
		$(document).on('click.funnel', "[data-funnel-cmd='close']", function(event) {
			event.preventDefault();

			window.location.hash = 'v=closed'; // using window.hash instead of pushState to remove all other parameters
			// $.bbq.pushState({v:'none'}
		});

		// Select a location
		$(document).on('click.funnel', '#steps-content .step-location li', function(event) {
			event.preventDefault();
			var $this = $(this),
				los   = $this.attr('data-funnel-location'),
				lon   = $this.find('h3:first').text(),
				ses   = locationFirst ? false : currentService,
				sen   = locationFirst ? false : serviceName;

			var view = locationFirst ? 'services' : 'counselors';

			$.bbq.pushState({ v: view, ls: los, ln: lon, ss: ses, sn: sen, cs: false, cn: false });
			// Temporary code to enhance gravity forms schedule popup 
			$('#schedule-form').find('li.form-locations select').val(lon);
		});

		// Select a service
		$(document).on('click.funnel', '#steps-content .step-service li', function(event) {
			event.preventDefault();
			var $this = $(this),
				los   = locationFirst ? currentLocation : false,
				lon   = locationFirst ? locationName : false,
				ses   = $this.attr('data-funnel-service'),
				sen   = $this.find('h3:first').text();

			var view = locationFirst ? 'counselors' : 'locations';

			$.bbq.pushState({ v: view, ls: los, ln: lon, ss: ses, sn: sen, cs: false, cn: false });
			// Temporary code to enhance gravity forms schedule popup 
			$('#schedule-form').find('li.form-services select').val(sen);
		});

		// Select a counselor
		$(document).on('click.funnel', '#steps-content .step-counselor li', function(event) {
			event.preventDefault();
			var $this = $(this),
				cos   = $this.attr('data-funnel-counselor'),
				con   = $this.find('h3:first').text();

			var view = 'schedule';

			$.bbq.pushState({ v: view, ls: currentLocation, ln: locationName, ss: currentService, sn: serviceName, cs: cos, cn: con });
			// Temporary code to enhance gravity forms schedule popup
			$('#schedule-form').find('li.form-providers select').val(con);
		});

		// Show panel
		$(document).on('click.funnel', "[data-funnel-cmd='showPanel'].completed", function(event) {
			event.preventDefault();
			var $this = $(this),
				panel = $this.attr('data-funnel-arg'),
				view;

			switch(panel) {
			    case 'locations':
					view = 'locations';
					if(locationFirst) {
						$.bbq.pushState({ v: view, ls: currentLocation, ln: locationName, ss: false, sn: false, cs: false, cn: false });
					} else {
						$.bbq.pushState({ v: view, ls: currentLocation, ln: locationName, ss: currentService, sn: serviceName, cs: false, cn: false });						
					}
			        break;
			    case 'services':
					view = 'services';

					if(locationFirst) {
						$.bbq.pushState({ v: view, ls: currentLocation, ln: locationName, ss: currentService, sn: serviceName, cs: false, cn: false });
					} else {
						$.bbq.pushState({ v: view, ls: false, ln: false, ss: currentService, sn: serviceName, cs: false, cn: false });						
					}
			        break;
			    default:
					view = 'counselors';

					$.bbq.pushState({ v: view, ls: currentLocation, ln: locationName, ss: currentService, sn: serviceName, cs: currentCounselor, cn: counselorName });
			}
		});

		function showFunnel() {
			// console.log('showFunnel');
			if (isBusy) { return; } // only close when not busy
			if(funnelShowing) {
				// console.log('funnelShowing');
				goToByScroll( $funnelSection );
				return;				
			}
			$funnelSection.fadeIn();
			if('header' !== $funnelButton.find('a:first').attr('data-funnel-type')) {
				$funnelButton.fadeOut( 'fast', function() {
					// Call the scroll function
					goToByScroll( $funnelSection );
					funnelShowing    = true;
				});
			} else {
					goToByScroll( $funnelSection );
					funnelShowing    = true;				
			}
		}

		function updateStepsNav($panel, state, value) {
			var $stepQuestion = $stepQuestions.find('.' + $panel.attr('class')),
	    	    $step = $('#' + $panel.attr('class')),
	    	    $span, $selection;
	    	$scheduleButton.html(''); // Clear the schedule button
			switch(state) {
			    case 'current':
			    	$span = $stepQuestion.find('h3 span');
			    	$selection = $step.find('.selection');
			    	$span.text($span.attr('data-funnel-default-text'));
			    	$selection.text($selection.attr('data-funnel-default-text'));
			    	$stepQuestion.find('h3').addClass('current');
			    	$stepQuestion.find('.step-inner').addClass('active');
			    	$step.addClass('active');
			        break;
			    case 'completed':
			    	$stepQuestion.find('h3').removeClass('current').addClass('completed');
			    	$stepQuestion.find('h3 span').text(value);
			    	$stepQuestion.find('.step-inner').removeClass('active');
			    	$step.addClass('completed');
			    	$step.find('.selection').text(value).addClass('flash');
			    	setTimeout(function() {
			    		$step.find('.selection').removeClass('flash');
			    	}, 1000);
			        break;
			    default:
			    	$span = $stepQuestion.find('h3 span');
			    	$selection = $step.find('.selection');
			    	$span.text($span.attr('data-funnel-default-text'));
			    	$selection.text($selection.attr('data-funnel-default-text'));
			    	$stepQuestion.find('h3').removeClass('current completed');
			    	$stepQuestion.find('.step-inner').removeClass('active');
			    	$step.removeClass('active completed');
			}
		}

		function hideFunnel() {
			if (isBusy || !funnelShowing) { return; } // only close when not busy
			$funnelButton.fadeIn();
			$funnelSection.fadeOut( 'fast', function() {
				// Call the scroll function
				goToByScroll( $funnelButton );
				// Clear the panels
				updateStepsNav($locationsPanel.html(''), 'clear');
				updateStepsNav($servicesPanel.html(''), 'clear');
				updateStepsNav($counselorsPanel.html(''), 'clear');
				updateStepsNav($schedulePanel.html(''), 'clear');
				currentLocation  = false;
				currentService   = false;
				currentCounselor = false;
				funnelShowing    = false;
			});
		}

		function showLoadingPanel() {
			isBusy = true;

			if ($visiblePanel) {
				$visiblePanel.hide(0,function(){
					$visiblePanel = false;
				});
			}

			$loadingPanel.fadeIn('fast');
		}

		function hideLoadingPanel($nextPanel) {
			$loadingPanel.hide();

			if ($nextPanel) {
				$nextPanel.fadeIn('fast', function(){
					$visiblePanel = $nextPanel;
					isBusy = false;
				});
			}
		}

		function loadPanel($panel, options, callback) {
			if (isBusy) { return; } // Do nothing if busy
			showLoadingPanel();
			$panel.load(
				ajaxURL,
				options, 
				function() {
					hideLoadingPanel($panel);
					updateStepsNav($panel, 'current');
					if (typeof callback !== "undefined") {
						callback();
					}
				}
			);
		}

		function setState() {
			var state = {
				v:  $.bbq.getState( "v" ), // locations, services, counselors, schedule
				ls: $.bbq.getState( "ls" ) === 'false' ? false : $.bbq.getState( "ls" ),
				ln: $.bbq.getState( "ln" ) === 'false' ? false : $.bbq.getState( "ln" ),
				ss: $.bbq.getState( "ss" ) === 'false' ? false : $.bbq.getState( "ss" ),
				sn: $.bbq.getState( "sn" ) === 'false' ? false : $.bbq.getState( "sn" ),
				cs: $.bbq.getState( "cs" ) === 'false' ? false : $.bbq.getState( "cs" ),
				cn: $.bbq.getState( "cn" ) === 'false' ? false : $.bbq.getState( "cn" )
			};

			switch (state.v) {
				case 'locations':
					showFunnel(); // Ensure the funnel is showing
					currentCounselor = false;
					counselorName    = '';
					var currentStep      = locationFirst ? 1 : 2;

					updateStepsNav($locationsPanel, 'current');

					currentLocation = state.ls ? state.ls : initialLocation;

					if(locationFirst) { // services comes after location
						// currentService  = initialService ? initialLocation : false;
						currentService  = false;
						serviceName     = '';
						updateStepsNav($servicesPanel.html(''), 'clear');
					} else {
						currentService  = state.ss ? state.ss : false;
						serviceName     = state.sn ? state.sn : '';
						updateStepsNav($servicesPanel, 'completed', serviceName);
					}

					updateStepsNav($counselorsPanel.html(''), 'clear');
					updateStepsNav($schedulePanel.html(''), 'clear');

					loadPanel(
						$locationsPanel,
						{
							action:    'funnel-locations-panel',
							location:   currentLocation,
							service:    currentService,
							counselor:  currentCounselor,
							step:       currentStep
						}
					);
				break;
				case 'services':
					showFunnel(); // Ensure the funnel is showing
					currentCounselor = false;
					counselorName    = '';
					currentStep      = locationFirst ? 2 : 1;

					updateStepsNav($servicesPanel, 'current');

					currentService = state.ss ? state.ss : initialService;

					if(locationFirst) { // services comes after location
						currentLocation = state.ls ? state.ls : false;
						locationName    = state.ln ? state.ln : '';
						updateStepsNav($locationsPanel, 'completed', locationName);
					} else {
						currentLocation   = false; // Do not use initial location since we want to show all available services
						locationName      = false;
						updateStepsNav($locationsPanel.html(''), 'clear');
					}

					updateStepsNav($counselorsPanel.html(''), 'clear');
					updateStepsNav($schedulePanel.html(''), 'clear');

					loadPanel(
						$servicesPanel,
						{
							action:    'funnel-services-panel',
							location:   currentLocation,
							service:    currentService,
							counselor:  currentCounselor,
							step:       currentStep							
						}
					);
				break;
				case 'counselors':
					showFunnel(); // Ensure the funnel is showing
					currentLocation  = state.ls ? state.ls : false;
					locationName     = state.ln ? state.ln : '';
					currentService   = state.ss ? state.ss : false;
					serviceName      = state.sn ? state.sn : '';
					currentCounselor = state.cs ? state.cs : false;
					counselorName    = state.cn ? state.cn : '';

					updateStepsNav($counselorsPanel, 'current');

					updateStepsNav($locationsPanel, 'completed', state.ln);
					updateStepsNav($servicesPanel, 'completed', state.sn);
					updateStepsNav($schedulePanel.html(''), 'clear');

					loadPanel(
						$counselorsPanel,
						{
							action:    'funnel-counselors-panel',
							location:   currentLocation,
							service:    currentService,
							counselor:  currentCounselor
						}
					);
				break;
				case 'schedule':
					showFunnel(); // Ensure the funnel is showing
					currentLocation  = state.ls ? state.ls : false;
					locationName     = state.ln ? state.ln : '';
					currentService   = state.ss ? state.ss : false;
					serviceName      = state.sn ? state.sn : '';
					currentCounselor = state.cs ? state.cs : false;
					counselorName    = state.cn ? state.cn : '';

					updateStepsNav($schedulePanel, 'current');

					updateStepsNav($locationsPanel, 'completed', locationName);
					updateStepsNav($servicesPanel, 'completed', serviceName);
					updateStepsNav($counselorsPanel, 'completed', counselorName);

					loadPanel(
						$schedulePanel,
						{
							action:    'funnel-schedule-panel',
							location:   currentLocation,
							service:    currentService,
							counselor:  currentCounselor
						},
						function() {
							var buttonHTML = $schedulePanel.find('.confirm-btn:first').html();
							$scheduleButton.html( buttonHTML );
							$stepQuestions.find('.popup-form').magnificPopup({
								type: 'inline',
								preloader: false
							});

							/**
							 * Scheduling Pop-Up
							 *
							 * @link https://github.com/dimsemenov/Magnific-Popup
							 */
							$stepQuestions.find('.popup-schedule').magnificPopup({
								type: 'iframe',
								preloader: false
							});

						}
					);
				break;
				default:
					hideFunnel();
			}
		}
		$(window).bind( "hashchange", setState);
		$(window).trigger( "hashchange" );

		window.openFunnel = function() {
			var view = locationFirst ? 'locations' : 'services';
			disableScroll = true;
			$.bbq.pushState({ v: view });
			setTimeout(function(){
				disableScroll = false;
			}, 200);
		};

		$(window).scroll(function(d,h) {
			if (!funnelShowing) {return;}
			var a = $funnelSection.offset().top + $funnelSection.height(),
				b = $(window).scrollTop(),
				c = $funnelSection.offset().top,
				m = 150;

			if (b > a - m || b < c - m) {
				if(!funnelButtonVis) {
					$funnelButton.fadeIn('fast', function() {
						funnelButtonVis = true;
					});
				}
			} else {
				if(funnelButtonVis) {
					$funnelButton.fadeOut('fast', function() {
						funnelButtonVis = false;
					});
				}
			}
		});

	}
	// setup_funnel();

	/**
	 * Change Active State of Links in Sticky Navigation on Scroll.
	 *
	 * @link http://codetheory.in/change-active-state-links-sticky-navigation-scroll/
	 * @link http://cssdeck.com/labs/setting-active-states-on-sticky-navigations-while-scrolling/
	 */	
	function setup_active_states_while_scrolling() {
		var sections = $('.sections section'),
		nav = $('nav.dynamic'),
		nav_top = $('nav.top'),
		nav_height = nav_top.outerHeight();
		
		$(window).on('scroll', function () {
		  var cur_pos = $(this).scrollTop();
		  
		  sections.each(function() {
		    var top = $(this).offset().top - nav_height,
		        bottom = top + $(this).outerHeight();
		    
		    if (cur_pos >= top && cur_pos <= bottom) {
		      nav.find('li').removeClass('active');
		      sections.removeClass('active');
		      
		      $(this).parent('li').addClass('active');
		      nav.find('a[href="#'+$(this).attr('id')+'"]').parent('li').addClass('active');
		    }
		  });
		});
		
		nav.find('a').on('click', function () {
		  var $el = $(this), 
		  id = $el.attr('href');
		  
		  $('html, body').animate({
		    scrollTop: $(id).offset().top - nav_height
		  }, 500);
		  
		  return false;
		});
	}
	setup_active_states_while_scrolling();

	/**
	 * Add tabbed profile navigation.
	 */
	function setup_profile_tab_nav() {

		// function to scroll up
		function goToByScroll($element) {
			if (!$element.length) {
				return;
			}
	
		    $('html,body').animate({
		        scrollTop: $element.offset().top-30
		    }, 'slow');
		}

		var $container = $('.tabbed');
		var $tabs = $container.find('.tabs > li');
		var $content = $container.find('.tab-content');
		var $tabs_bottom = $container.find('.back-to-tabs');
		
		function activated_tabs(active_anchor) {

			//get displaying tab content jQuery selector
			var target_content_selector = $(active_anchor).attr('href');
			
			//find actived navigation and remove 'active' css
			$tabs.removeClass('active');
			$tabs_bottom.find('a').removeClass('active');
			//hide displaying tab content
			$(active_anchor).closest('li').addClass('active');
			//console.log(target_content_selector);
			$($tabs_bottom).find('a[href="'+target_content_selector+'"]').addClass('active');

			$content.removeClass('active');
			//show target tab content
			$(target_content_selector).addClass('active');		
		}		
		
		$tabs.find('> a').click(function(e){
			e.preventDefault();
			activated_tabs(this);		
		});
		
		// scroll back to top tabs
		$container.find('.back-to-tabs a').click(function(e){
		    e.preventDefault();
		    
			var target_href = $(this).attr('href');
			var target_anchor = $tabs.find('a[href="'+target_href+'"]');

			activated_tabs(target_anchor);					    
		    
		    // Call the scroll function
		    goToByScroll($container);
		});
	}
	setup_profile_tab_nav();
	
	function setup_back_to_top() {
		
		var $top = $('#articles-wrap');
		var $back_to_top = $('.share-links li.top');
		
		// function to scroll up
		function goToByScroll($element) {
			if (!$element.length) {
				return;
			}
	
		    $('html,body').animate({
		        scrollTop: $element.offset().top
		    }, 'slow');
		}
		
		$back_to_top.find('a').click(function(e) {
			e.preventDefault();
			
			// Call the scroll function
			goToByScroll($top);	
		});			
	}
	setup_back_to_top();
	
	/**
	 * Read more/less toggle class
	 *
	 * @link http://jedfoster.com/Readmore.js/
	 */
	function setup_toggles() {
		$('.toggle').readmore({
			speed: 75,
			collapsedHeight: 40,
			moreLink: '<a href="#"><i class="fa fa-caret-right"></i></a>',
			lessLink: '<a href="#"><i class="fa fa-caret-down"></i></a>'
		});
		
		$('.toggle-plus').readmore({
			speed: 75,
			collapsedHeight: 20,
			moreLink: '<a href="#"><i class="fa fa-plus-square"></i></a>',
			lessLink: '<a href="#"><i class="fa fa-minus-square"></i></a>'
		});

		$('.toggle-plus-text').readmore({
			speed: 75,
			collapsedHeight: 20,
			moreLink: '<a href="#"><i class="fa fa-plus-square"></i> show more</a>',
			lessLink: '<a href="#"><i class="fa fa-minus-square"></i> show less</a>'
		});
		
        $('.author-bio p, #counselor-single .short-bio p').readmore({	        
            speed: 75,
            heightMargin: 50,
            moreLink: '<a href="#">More<i class="fa fa-caret-right"></i></a>',
            lessLink: '<a href="#">Less<i class="fa fa-caret-up"></i></a>'
        });
        
        $('.style-list .short-bio p').readmore({	        
            speed: 75,
            heightMargin: 24,
            moreLink: '<a href="#">More<i class="fa fa-caret-right"></i></a>',
            lessLink: '<a href="#">Less<i class="fa fa-caret-up"></i></a>'
        });        
	}
	setup_toggles(); 

	/**
	 * Initiate magnific popup
	 *
	 * @link https://github.com/dimsemenov/Magnific-Popup
	 */
	$('.location-tour a').magnificPopup({
		type: 'iframe'
	});

	function setup_schedule_popup() {
		var $body  = $('body').first(),
			$form  = $('#schedule-form'),
			data   = [];
		if ($body.hasClass('page-template-directory-listing-page')) {
			data = JSON.parse(document.getElementById('directory-json').innerHTML);

			$form.find('li.form-providers select').on('change', function(event) {
				// event.preventDefault();
				var name      = $(this).val(),
					locations = data[name].locations,
					services  = data[name].services;
				$form.find('li.form-locations select option').each(function(index, el) {
					var $this = $(this);
					if(-1 !== locations.indexOf($this.val())) {
						$this.removeAttr('disabled');
					} else {
						$this.attr('disabled', true);
					}
				});
				$form.find('li.form-services select option').each(function(index, el) {
					var $this = $(this);
					if(-1 !== services.indexOf($this.val())) {
						$this.removeAttr('disabled');
					} else {
						$this.attr('disabled', true);
					}
				});				
			});
		}

		$(document).magnificPopup({
			delegate: '.popup-form',
			type: 'inline',
			preloader: false,
			callbacks: {
				beforeOpen: function() {
					var $link = this.st.el,
						isSecondary = !!$link.parents('#secondary-search-results').length,
						name  = $link.attr('data-counselor-name'),
						location,
						locationId,
						service,
						serviceId,
						t;

					// Check if we're in the directory:
					if ($body.hasClass('page-template-directory-listing-page')) {

						// Get the selected location & service if any:
						location = $('input[name="location"]:checked');
						service  = $('input[name="service"]:checked');
						
						locationId = location.length && !isSecondary ? location.prop('id') : '';
						serviceId  = service.length  ? service.prop('id')  : '';

						// Pre-fill the form:
						$form.find('li.form-providers select').val(name).change();

						if ('' !== locationId) {
							location = $('label[for="' + locationId + '"]');
							location = location.contents().filter(function(){ 
	  							return this.nodeType === 3;
							});
							t = location[0].nodeValue;
							$form.find('li.form-locations select').val(t);
						} else {
							$form.find('li.form-locations select').val('');
						}

						if ('' !== serviceId) {
							t = $('label[for="' + serviceId + '"]').text();
							$form.find('li.form-services select').val(t);
						} else {
							$form.find('li.form-services select').val('');
						}
					}
				}
			}
		});
	}
	setup_schedule_popup();

	/**
	 * Scheduling Pop-Up
	 *
	 * @link https://github.com/dimsemenov/Magnific-Popup
	 */
	$('body').magnificPopup({
		delegate: '.popup-schedule',
		type: 'iframe',
		preloader: false
	});

	// Create IE + others compatible event handler
	var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	var eventer = window[eventMethod];
	var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

	// Listen to message from child window
	eventer(messageEvent,function(e) {
	  if( e.data === 'close_popup' ) {
	  	$.magnificPopup.close();
	  }
	},false);

			
	if ( $("#schedule-form").length ) {
		$( "#schedule-form .gform_footer" ).insertAfter( $( ".last-field .gsection_title" ) );
		$(".gform_wrapper .readonly input").attr("readonly", "");
	}
	
	/**
	 * Initiate ScrollToFixed
	 *
	 * @link https://github.com/bigspotteddog/ScrollToFixed
	 */
	 if ($('#extended-info .tabs').length) {
	 	$('.tabs').scrollToFixed({ 
		 	marginTop: 10,
		 	limit: $( $('h2.section_title').last() ).offset().top
		});
	 }	 
	 
	 if ($('.stick').length) {
	 	$('.stick').scrollToFixed({ marginTop: 40, limit: $('.share-links').offset().top - 167 });
	 }
	 
	 if ($('.optin-monster-api').length) {
	 	$('.optin-monster-api').scrollToFixed({ marginTop: 20, limit: $('footer').offset().top });
	 }  
			 				 
});